import { authApi } from './authApi';

export const getSignatureType = async () => {
  return await authApi.get('stylus/signature-type/');
};

export const updateSignatureType = async (payload: any) => {
  return await authApi.patch(
    `stylus/signature-type/${payload.id}/`,
    payload.body
  );
};

export const getTableColumn = async () => {
  return await authApi.get('admin/table_columns/');
};

export const updateTableColumn = async (payload: any) => {
  if (payload.id) {
    const response = await authApi.patch(
      `admin/table_columns/${payload.id}/`,
      payload.body
    );
    return {
      response,
      table_name: payload.body.table_name,
    };
  } else {
    const response = await authApi.post('admin/table_columns/', payload.body);
    return {
      response,
      table_name: payload.body.table_name,
    };
  }
};

export const getStatus = async () => {
  return await authApi.get('stylus/status/');
};

export const updateStatusAlias = async (payload: any) => {
  return await authApi.patch('stylus/status-update/', payload);
};

export const uploadSeal = async (payload: any) => {
  return await authApi.post('admin/seal/', payload);
};

export const getSeal = async () => {
  return await authApi.get('admin/seal/');
};

export const downloadSeal = async (id: string) => {
  return await authApi.get(`admin/seal/download/${id}/`, {
    responseType: 'arraybuffer',
  });
};

export const deleteSeal = async (payload: any): Promise<any> => {
  return await authApi.delete('admin/seal/', { data: payload });
};

export const getWorkingHours = async () => {
  return await authApi.get('admin/working-hours/');
};

export const updateWorkingHours = async (payload: any) => {
  if (payload.id) {
    return await authApi.put('admin/working-hours/', payload.data);
  } else {
    return await authApi.post('admin/working-hours/', payload.data);
  }
};

export const addFreeField = async (payload: any) => {
  if (payload.id) {
    return await authApi.patch(
      `admin/agreement-date-config/${payload.id}/`,
      payload.data
    );
  } else {
    return await authApi.post('admin/agreement-date-config/', payload.data);
  }
};

export const getFreeField = async () => {
  return await authApi.get('admin/agreement-date-config/');
};
